import { monthlyFootnoteFormatter } from 'app/components/questions/base'
import { SingleQuestion } from 'app/components/questions/single'
import { genericChangeCTA } from 'app/containers/PipelineSection/Expenses'
import * as React from 'react'

const CharityQuestionsGroup = () => (
  <SingleQuestion
    header="Charity"
    icon="fa fa-fw fa-briefcase"
    headerDescription="In this section, you'll be entering your expenses for charity."
    question={{
      placeholder: 'Enter your current monthly charity expenses',
      name: 'expenses.charity.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'monthly',
    }}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your monthly charity expenses during retirement',
        name: 'expenses.charity.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'monthly',
      }
    }} />
)

const TaxesQuestionsGroup = () => (
  <SingleQuestion
    header="Taxes"
    icon="fa fa-fw fa-briefcase"
    headerDescription="In this section, you'll be entering your expenses for taxes."
    question={{
      placeholder: 'Enter your current annual tax expenses',
      name: 'expenses.taxes.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'yearly',
    }}
    itemFootnoteFormatter={monthlyFootnoteFormatter}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your annual tax expenses during retirement',
        name: 'expenses.taxes.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'yearly',
      },
      itemFootnoteFormatter: monthlyFootnoteFormatter
    }}
    footer={'Keep in mind that most retirement benefits can be taxed upon payment.  The amount of taxes to be paid will vary based on a number of factors, including the type of benefit and your annual income.  As a result, your taxes could be different after retirement.  You may need to seek guidance from a tax professional on what to expect during retirement based on your specific situation.'}
  />
)

const SavingsDebtQuestionsGroup = () => (
  <SingleQuestion
    header="Large Expense Budgeting"
    icon="fa fa-fw fa-briefcase"
    headerDescription="In this section, you'll be entering the amount you are setting aside in anticipation of a future large expenditure (e.g., purchasing boat, dream vacation)."
    headerDescriptionInfo="This page can also be used to account for debt payments (e.g., credit cards) that are not covered on other pages."
    question={{
      placeholder: 'Enter your current annual savings and debt expenses',
      name: 'expenses.savingsAndDebt.beforeRetirement',
      type: 'text',
      formattedNumberMode: true,
      unit: 'yearly',
    }}
    itemFootnoteFormatter={monthlyFootnoteFormatter}
    option={{
      callToAction: genericChangeCTA,
      question: {
        placeholder: 'Enter your annual savings and debt expenses during retirement',
        name: 'expenses.savingsAndDebt.afterRetirement',
        type: 'text',
        formattedNumberMode: true,
        unit: 'yearly',
      },
      itemFootnoteFormatter: monthlyFootnoteFormatter
    }} />
)

export {
  CharityQuestionsGroup,
  TaxesQuestionsGroup,
  SavingsDebtQuestionsGroup,
}



// WEBPACK FOOTER //
// ./src/app/containers/PipelineSection/Expenses/Other/index.tsx